  import { getUserWithProfile, type CombinedUser } from '@/lib/collections/workerProfile-Users/getUserWithProfile';
  import RequestUser from '@/requests/certificates/employmentCertificate/views/user/requestUser';
  import EmployeeRequestsView from '@/requests/certificates/employmentCertificate/views/user/user';


  import { createFileRoute, redirect } from '@tanstack/react-router';

  export const Route = createFileRoute('/_authenticated/requests/$id/certifies/')({
    beforeLoad: ({ context }) => {
      if (!context.user) throw redirect({ to: '/login' });
      // // Solo RRHH y Admin pueden acceder
      // if (!context.userRoles.isRRHH && !context.userRoles.isAdmin) {
      //   throw redirect({ to: '/unauthorized' });
      // }
    },
    loader: async ({ params }) => {
      const user = await getUserWithProfile(params.id);
      if (!user) throw new Error("Usuario no encontrado");
      return user;
    },
    component: UserDetail,
  });

  function UserDetail() {
    const user = Route.useLoaderData() as CombinedUser;
    return (

      <>
        <RequestUser user={user} />
        <EmployeeRequestsView />
      </>
    )
  }
